var __rspack_ns_object = JSON.parse('{"N":"localStorage","M":""}')